import routes from './routes'
import { Fetch } from '../fetch'

class AllAvaliableLoads {
  getAll ({ offset, body = {} }) {
    return Fetch('post', routes.getAll({ offset }), body)
  }

  markUnmark ({ movementNumber, isMark }) {
    return Fetch('get', routes.markUnmarkAll(movementNumber, isMark), null)
  }
}

export default new AllAvaliableLoads()
